import { callApi } from './config/callApi'

type TransactionData = {
  amount_stars?: number
  commission?: number
  type?: 'DEPOSIT' | 'TRANSFER' | 'WITHDRAWAL' | 'INVESTMENT' | 'WIN' | 'LOSE' | ''
  recipient?: number
  gift_id?: string
  wallet?: string
  withdrawalType?: 'TON' | 'USDT' | ''
}

export const createUserTransactions = async (data: TransactionData): Promise<any> => {
  // const initialData = {
  //   amount_stars: 0,
  //   commission: 0,
  //   type: '',
  //   recipient: 0,
  //   gift_id: '',
  //   wallet: '',
  //   withdrawalType: '',
  // }

  const finalData = { ...data }

  console.log('finalData', finalData)

  return callApi({
    method: 'post',
    url: '/transactions',
    data: finalData,
  })
}

export const getUserTransactions = async (id?: number): Promise<any> => {
  const url = id ? `/transactions/${id}` : '/transactions'

  return callApi({
    method: 'get',
    url,
  })
}

export const getUserTransaction = async (id?: number): Promise<any> => {
  return callApi({
    method: 'get',
    url: `/transactions/${id}`,
  })
}
